module.exports = __webpack_public_path__ + "img/073623.62a769b3.png";